<template>
  <div class="page">
    <div class="container py-3">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <div class="portfolio-shell">
            <div class="text-center mb-2">
              <p class="eyebrow">Selected work</p>
              <h1>Projects that balance design, clarity, and performance.</h1>
              <p class="lead">
                These sites reflect a mix of professional branding, storytelling, and clean user experience.
              </p>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3" v-for="project in projects" :key="project.name">
                <div class="project-card">
                  <h3>{{ project.name }}</h3>
                  <p>{{ project.description }}</p>
                  <a :href="project.url" target="_blank" rel="noopener noreferrer">Visit site</a>
                </div>
              </div>
            </div>

            <div class="cta-card">
              <h3>Ready to create something similar?</h3>
              <p>Let’s turn your next website into a polished, high-converting experience.</p>
              <router-link to="/Contact" class="btn btn-primary">Start a Conversation</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      projects: [
        {
          name: "American Energy Consulting",
          description: "A professional consulting website focused on trust, clarity, and authority.",
          url: "http://www.AmericanEnergyConsulting.com",
        },
        {
          name: "Artist ERJ",
          description: "A streamlined portfolio experience for an artistic brand and personal identity.",
          url: "http://www.Artist-ERJ.com",
        },
        {
          name: "Chicago Artwork",
          description: "A refined site designed to showcase artistic work with a strong visual presentation.",
          url: "http://www.Chicago-Artwork.com",
        },
        {
          name: "Chicago River Paddle",
          description: "A clear and inviting website that makes outdoor experiences easy to discover.",
          url: "http://www.ChicagoRiverPaddle.com",
        },
        {
          name: "Eric Johnson Resume",
          description: "A polished personal brand page built with professional structure and readability.",
          url: "http://www.EricJohnsonResume.com",
        },
        {
          name: "IMEJ Tech",
          description: "A modern service website with a professional layout and clear conversion path.",
          url: "http://www.ImejTech.com",
        },
      ],
    };
  },
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  /* animation: backgroundMove 120s ease-in-out infinite; */
}
.portfolio-shell {
  background: rgba(7, 17, 31, 0.9);
  border-radius: 14px;
  padding: 18px 22px;
  color: white;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
}
.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.7rem;
  color: #c5d4ff;
  margin-bottom: 4px;
}
h1 {
  font-size: 1.45rem;
  margin-bottom: 8px;
  line-height: 1.2;
}
.lead {
  color: #dde7ff;
  margin-bottom: 12px;
  font-size: 0.95rem;
  line-height: 1.6;
}
.project-card,
.cta-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 12px 14px;
  height: 100%;
}
.project-card h3 {
  font-size: 0.95rem;
  margin-bottom: 4px;
}
.project-card p,
.cta-card p {
  color: #e4ecff;
  line-height: 1.5;
  margin-bottom: 6px;
  font-size: 0.9rem;
}
.project-card a {
  color: #7dd3fc;
  font-weight: 600;
  font-size: 0.8rem;
  display: inline-block;
  margin-top: 2px;
}
.cta-card {
  margin-top: 8px;
}
@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
